module.exports = __webpack_public_path__ + "static/Dentures intraoral before-e7246b9bd74cf5bd6cb12698dab1c897.jpg";